import React, { useEffect } from 'react';
import {
  Container,
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import AOS from 'aos';
import 'aos/dist/aos.css';
import GavelIcon from '@mui/icons-material/Gavel';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';

const StyledCard = styled(Card)(({ theme }) => ({
  height: '100%',
  background: 'rgba(255, 255, 255, 0.95)',
  borderRadius: theme.spacing(2),
  transition: 'all 0.3s ease-in-out',
  '&:hover': {
    transform: 'translateY(-10px)',
    boxShadow: theme.shadows[10],
  },
}));

const PeacePromotionAndDemocratization = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <Box sx={{ mt: 10, pb: 10 }}>
      <Container maxWidth="lg">
        <Typography
          variant="h3"
          sx={{
            fontWeight: 700,
            textAlign: 'center',
            mb: 6,
            color: '#1E88E5',
          }}
        >
          Peace Promotion & Supporting Democratization
        </Typography>

        <Grid container spacing={6}>
          {/* Peace Promotion */}
          <Grid item xs={12} md={6}>
            <div data-aos="fade-up">
              <StyledCard>
                <CardContent>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <EmojiPeopleIcon
                      color="primary"
                      sx={{ fontSize: 40, mr: 1 }}
                    />
                    <Typography variant="h5" fontWeight={600}>
                      Peace Promotion
                    </Typography>
                  </Box>
                  <Typography variant="body1" color="text.secondary">
                    Promoting peace and peaceful coexistence among ethnic and social groups in Oromia and neighboring regions:
                    <ul>
                      <li>Promoting intra- and inter-ethnic/social group peaceful coexistence</li>
                      <li>Facilitating peace-maintaining structures (forums, early-warning committees, etc.)</li>
                      <li>Supporting existing peace-building initiatives</li>
                      <li>Utilizing indigenous conflict resolution and coexistence methods</li>
                    </ul>
                  </Typography>
                </CardContent>
              </StyledCard>
            </div>
          </Grid>

          {/* Supporting Democratization */}
          <Grid item xs={12} md={6}>
            <div data-aos="fade-up" data-aos-delay="200">
              <StyledCard>
                <CardContent>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <GavelIcon
                      color="primary"
                      sx={{ fontSize: 40, mr: 1 }}
                    />
                    <Typography variant="h5" fontWeight={600}>
                      Supporting Democratization
                    </Typography>
                  </Box>
                  <Typography variant="body1" color="text.secondary">
                    Encouraging democratic participation and electoral involvement:
                    <ul>
                      <li>Supporting voter education initiatives</li>
                      <li>Mobilizing CSOs for election observation</li>
                      <li>Mobilizing CSOs for election monitoring and evaluation</li>
                    </ul>
                  </Typography>
                </CardContent>
              </StyledCard>
            </div>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default PeacePromotionAndDemocratization;
